import { dncType } from "./dnc.type";

const initialState = {
  dncList: [],
  dncListCount: [],
};

function DNCReducer(state = initialState, action) {
  switch (action.type) {
    case dncType.GET_DNC_LIST: {
      return { ...state, dncList: action.payload };
    }
    case dncType.GET_DNC_LIST_COUNT: {
      return { ...state, dncListCount: action.payload };
    }
    default:
      return state;
  }
}

export default DNCReducer;
